<div class="bulk-upload-modal">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-content">
        <h2 *ngIf="uploadType === 'excel'">Excel Upload</h2>
        <h2 *ngIf="uploadType === 'raw'">Raw File Upload</h2>
        <p class="subtitle" *ngIf="uploadType === 'excel'">Upload excel sheet to update multiple wells at once.</p>
        <p class="subtitle" *ngIf="uploadType === 'raw'">Upload Raw data files to update multiple wells at once.</p>
      </div>
      <button class="download-button" 
              *ngIf="uploadType === 'excel'"
              (click)="downloadTemplate()" 
              [disabled]="isUploading || isDownloadingTemplate">
        <span class="icon" *ngIf="!isDownloadingTemplate">download</span>
        <span class="loader" *ngIf="isDownloadingTemplate"></span>
        {{ isDownloadingTemplate ? 'Downloading...' : 'Template' }}
      </button>
      <button class="back-button" (click)="goBack()" [disabled]="isUploading">
        <span class="icon">arrow_back</span>
        Back to Wells
      </button>
    </div>

    <!-- Uploading/Validation State -->
    <div class="uploading-state" *ngIf="isUploading || isValidationFailed">
      <!-- Show spinner and message when uploading (not validation failed) -->
      <div *ngIf="isUploading" class="upload-state-content">
        <div class="upload-spinner"></div>
        <p class="uploading-text">{{ statusMessage || 'Processing...' }}</p>
        
        <!-- Progress Bar -->
        <div class="progress-bar-container" *ngIf="progressPercentage > 0">
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="progressPercentage"></div>
          </div>
          <p class="progress-percentage">{{ progressPercentage }}%</p>
        </div>
        
        <!-- Detailed Progress Info -->
        <div class="progress-details" *ngIf="uploadStatus?.progress">
          <p class="progress-info" *ngIf="uploadStatus.progress.wells_processed !== undefined">
            <span class="info-label">Wells Processed:</span>
            <span class="info-value">{{ uploadStatus.progress.wells_processed }} of {{ uploadStatus.progress.total_wells }}</span>
          </p>
          <p class="progress-info" *ngIf="uploadStatus.progress.sheets_processed !== undefined">
            <span class="info-label">Sheets Processed:</span>
            <span class="info-value">{{ uploadStatus.progress.sheets_processed }} of {{ uploadStatus.progress.total_sheets }}</span>
          </p>
        </div>
      </div>

      <!-- When Validation Failed - Show selected file -->
      <div class="validation-failed-wrapper" *ngIf="isValidationFailed">
        <div class="selected-file-info" *ngIf="selectedFile">
          <button type="button" class="clear-btn" (click)="clearSelectedFile()" title="Clear selection">
            <span class="material-icons" style="width: 18px; height: 18px; font-size: 18px;">close</span>
          </button>
          <span class="material-icons" style="width: 24px; height: 24px; font-size: 24px;">description</span>
          <span>{{ selectedFile.name }}</span>
        </div>
      </div>
    </div>

    <!-- Drop Zone (shown when no file selected or validation failed) -->
    <!-- Drop Zone (unified for both empty and selected states) -->
    <div class="drop-zone"
         [class.drag-over]="isDragOver && !selectedFile"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         *ngIf="!isUploading && !isValidationFailed">
      
      <!-- Empty State Content -->
      <ng-container *ngIf="!selectedFile">
        <span class="upload-icon material-icons" style="font-size: 48px; width: 48px; height: 48px;">cloud_upload</span>

        <p class="drop-text">Drag your file here</p>
        <p class="drop-subtext">or <span class="browse-link" (click)="openFileDialog(); $event.stopPropagation()">click to browse</span></p>
      </ng-container>

      <!-- Selected File Content -->
      <ng-container *ngIf="selectedFile">
        <div class="selected-file-box">
          <button type="button" class="clear-btn" (click)="clearSelectedFile()" title="Clear selection">
            <span class="material-icons" style="width: 18px; height: 18px; font-size: 18px;">close</span>
          </button>

          <span class="file-icon material-icons" style="font-size: 48px; width: 48px; height: 48px;">description</span>

          <p class="selected-file-name">{{ selectedFile.name }}</p>
        </div>
      </ng-container>

      <input type="file" 
             id="file-input" 
             [accept]="uploadType === 'excel' ? '.xlsx,.xls' : '.zip'" 
             (change)="onFileSelect($event)" 
             style="display: none;">
    </div>

    <!-- File Format and Size Info -->
    <div class="file-info-bottom" *ngIf="!isUploading && !isValidationFailed">
      <span class="support-icon material-icons" style="width: 18px; height: 18px; font-size: 18px;">info</span>
      <span class="support-text" *ngIf="uploadType === 'excel'">Supported files: .xls, .xlsx</span>
      <span class="support-text" *ngIf="uploadType === 'raw'">Supported files: .zip</span>
      <span class="max-size">Maximum size: 5MB</span>
    </div>

    <!-- Validate & Upload Button -->
    <div class="button-container" *ngIf="!isUploading && !isValidationFailed">
      <button type="button" 
              class="validate-upload-btn" 
              (click)="validateAndUpload()"
              [disabled]="!selectedFile">
        Validate & Upload
      </button>
    </div>

    <!-- Validation Errors Button (shown when validation failed) -->
    <div class="button-container" *ngIf="isValidationFailed && validationErrors.length > 0">
      <button type="button" 
              class="validation-errors-btn" 
              (click)="showValidationErrors()">
        <span class="material-icons">error_outline</span>
        Validation Errors ({{ validationErrors.length }})
      </button>
      <p class="retry-hint">Select a different file or fix the issues and retry.</p>
    </div>

    <!-- Validation Errors Modal -->
    <div class="validation-errors-modal" *ngIf="showValidationErrorsModal" (click)="closeValidationErrorsModal()">
      <div class="modal-overlay" (click)="$event.stopPropagation()"></div>
      <div class="modal-stack" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h3>
            <span class="dialog-icon material-icons">cancel</span>
            Validation Errors
          </h3>
          <button class="close-btn" (click)="closeValidationErrorsModal()">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="errors-list">
            <div class="error-item" *ngFor="let error of validationErrors; let i = index">
              <div class="error-number">{{ i + 1 }}</div>
              <div class="error-content">
                <!-- Handle detailed validation errors (missing columns format) -->
                <div *ngIf="hasDetailedErrorInfo(error)" class="error-details">
                  <p class="error-sheet"><strong>Sheet:</strong> {{ error.sheet_name }}</p>
                  <p class="error-missing"><strong>Missing Columns:</strong></p>
                  <ul class="missing-columns-list">
                    <li *ngFor="let col of error.missing_columns">{{ col }}</li>
                  </ul>
                  <p class="error-msg" *ngIf="error.error_message">{{ error.error_message }}</p>
                </div>
                <!-- Handle simple error message format -->
                <div *ngIf="!hasDetailedErrorInfo(error)" class="error-simple">
                  <p class="error-message">{{ getErrorDisplayText(error) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="upload-new-btn" (click)="uploadNew()">
            Upload New
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
